import axios from "./axios"

export default {
    // get(cb, cartId) {
    //     setTimeout(() => { cb(carts[0]) }, 1000)
    // },

    getAll(cb) {
        setTimeout(() => { cb(carts) }, 1500)
    },

    search(cb, options) {
        setTimeout(() => { cb(carts) }, 500)
    },

    get(cartId, cb) {
        axios.get("/carts/" + cartId).then(r => {
            cb(r.data)
        })
    },

    scan(data, cb) {
        axios.post("/carts/scan", data).then(r => {
            cb(r.data)
        })
    },

    scanTo(data, cb) {
        axios.post("/trackingorders/scan", data).then(r => {
            cb(r.data)
        })
    }
}